const PrioridadTemplate = (option) => {
    const getColor = ()=>{
        if(option.id === 1959){
            return 'red'
        }else if(option.id === 1960){
            return 'orange'
        }else if(option.id ===1961){
            return '#ffd13f'
        }
    }

    return (
        <div className="country-item" style={{color:getColor(), fontWeight:'500'}}>
            <div>{option.nombre}</div>
        </div>
    );
}

export default PrioridadTemplate